import React from 'react'
import {BrowserRouter as Router,Route} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import Header from './components/Header.js'
import Footer from './components/Footer.js'
import NewAccountScreen from './screens/NewAccountScreen.js'


function App() {
  return (
    <Router> 
    <Header/>
    <main className ='py-3'>
     <Container>
    
      < Route path='/'  component={NewAccountScreen}/>
       
     
     </Container>
    </main>
    <Footer/>
</Router> 

   
  )
}

export default App;
